import React from 'react';
import { Card, Tag, Typography } from 'antd';

const { Text } = Typography;

const SearchOverview = ({ filters }) => {
  const formatRange = (range, enabled, unit = '') => {
    if (!enabled) return '_';
    return `${range[0].toLocaleString()} bis ${range[1].toLocaleString()} ${unit}`;
  };

  return (
    <Card title="Ihre Suchübersicht" className="wz-overview-card" style={{ marginTop: '20px' }}>
      <div style={{ marginBottom: '10px' }}>
        <Text strong>eBKP: </Text>
        {filters.codes.length > 0 ? (
          filters.codes.map(code => (
            <Tag key={code} color="green">{code}</Tag>
          ))
        ) : (
          <Text type="secondary">Keine ausgewählt</Text>
        )}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Text strong>Kanton: </Text>
        {filters.kanton.length > 0 ? (
          filters.kanton.map(k => (
            <Tag key={k} color="blue">{k}</Tag>
          ))
        ) : (
          <Text type="secondary">Keine ausgewählt</Text>
        )}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Text strong>Objektarten Hauptgruppe: </Text>
        {filters.buildingType.length > 0 ? (
          filters.buildingType.map(type => (
            <Tag key={type} color="orange">{type}</Tag>
          ))
        ) : (
          <Text type="secondary">Keine ausgewählt</Text>
        )}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Text strong>Geschossfläche: </Text>
        <Text>{formatRange(filters.sizeRange, filters.sizeRangeEnabled, 'm² GF')}</Text>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Text strong>Gebäudevolumen: </Text>
        <Text>{formatRange(filters.volRange, filters.volRangeEnabled, 'm³ GV')}</Text>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Text strong>Geschossfläche oberirdisch: </Text>
        <Text>{formatRange(filters.oberirdischRange, filters.oberirdischRangeEnabled, 'm² GFoi')}</Text>
      </div>

      <div>
        <Text strong>Baudatum: </Text>
        <Text>{formatRange(filters.yearRange, filters.yearRangeEnabled)}</Text>
      </div>
    </Card>
  );
};

export default SearchOverview;